import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=1efa5084&"
import script from "./SidebarItem.vue?vue&type=script&lang=js&"
export * from "./SidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports